<template>
    <div class="tco-tool__popout-grid-models">
        <label class="tco-tool__popout-label">Please select a model</label>
        <div class="tco-tool__popout-grid-model-list">
            <PopoutGridModel v-for="model in availableModels" :key="model.id" :brand="brand" :model="model" :is-electric="isElectric"
                v-on:model-selected="modelSelected">
            </PopoutGridModel>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import PopoutGridModel from './PopoutGridModel.vue';

export default {
    components: {
        PopoutGridModel
    },
    props: {
        brand: {
            required: true,
            type: Object
        },
        isElectric: {
            required: false,
            default: false,
        }
    },
    data() {
        return {};
    },
    methods: {
        ...mapMutations([
            'setSelectedEvModel',
            'setSelectedIceModel',
            'setSelectedEvTrim',
            'setSelectedIceTrim',
            'setSelectedEvVehicle',
            'setSelectedIceVehicle',
        ]),
        modelSelected(model) {
            if (this.isElectric) {
                this.setSelectedEvTrim(null);
                if (!model || !this.selectedModel || model.id != this.selectedModel.id) {
                    this.setSelectedEvTrim(null);
                    this.setSelectedEvVehicle(null);
                }

                this.$emit('model-selected', this.model);
                return this.setSelectedEvModel(model);
            }

            this.setSelectedIceTrim(null);
            if (!model || !this.selectedModel || model.id != this.selectedModel.id) {
                this.setSelectedIceTrim(null);
                this.setSelectedIceVehicle(null);
            }

            this.$emit('model-selected', this.model);
            return this.setSelectedIceModel(model);
        }
    },
    computed: {
        ...mapState(['evModels', 'iceModels', 'selectedEvModel', 'selectedIceModel']),
        selectedModel() {
            if (this.isElectric) {
                return this.selectedEvModel;
            }
            return this.selectedIceModel;
        },
        availableModels() {
            if (this.isElectric) {
                return this.evModels;
            }
            return this.iceModels;
        }
    },
}
</script>